// extracted by mini-css-extract-plugin
export var addWidgetButton = "_o-6";
export var backButton = "_o-1";
export var pageContainer = "_o-2";
export var settingsContent = "_o-0";
export var widgetContainer = "_o-5";
export var widgetSubsectionItem = "_o-3";
export var widgetSubsectionItemContent = "_o-4";